import { fork, all, call, put, select } from 'redux-saga/effects';
import waitForSession from '../../../lib/wait-for-session';
import { getUserId } from '../../session/getters';
import { selectedTicketId } from '../../my-tickets/getters'; // TODO move to yourorder
import {
  cancel,
  requestTicket
} from '../../../lib/api-helper';
import {
  ON_YOUR_ORDER_SUCCESS,
  ON_YOUR_ORDER_ERROR,
  YOUR_ORDER_CANCEL_ORDER_SUCCESS,
  YOUR_ORDER_CANCEL_ORDER_ERROR
} from '../actions';
import {
  ADD_FLASH_MESSAGE
} from '../../my-tickets/actions';

export function* requestAndPut(requestParameters, actionCreator) {
  const result = yield call(...requestParameters);
  yield put(actionCreator(result));
}

export const requestCurrentOrderActionCreator = order => ({
  type: ON_YOUR_ORDER_SUCCESS,
  payload: order ? order : false
});

export function* fetchYourOrderData(orderId) {
  yield call(waitForSession);
  const userId = yield select(getUserId);

  try {
    if (!userId) {
      throw new Error('No user - aborting');
    }

    yield all([
      fork(requestAndPut, [requestTicket, orderId.id], requestCurrentOrderActionCreator)
    ]);
  }
  catch (e) {
    yield put({ type: ON_YOUR_ORDER_ERROR, payload: e });
  }
}

export function* cancelOrder()  {
  try {
    const ticketId =  yield select(selectedTicketId);
    const res = yield cancel(ticketId);

    if (res && res.errors) {
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'cancelOrderError' }});
    }
    else {
      yield put({ type: YOUR_ORDER_CANCEL_ORDER_SUCCESS, ticketId });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'success', message: 'cancelOrderSuccess' }});
    }
  }
  catch (e) {
    yield put({ type: YOUR_ORDER_CANCEL_ORDER_ERROR, e });
    yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'cancelOrderError' }});
  }
}



// WEBPACK FOOTER //
// ./src/modules/your-order/actions/sagas.js